
    import { css } from 'lit-element';
    export default css`:host{--border-color:#879596;--background:#fff}`;
  